import { I18nProvider } from './i18n';
import Header from './components/Header';
import Footer from './components/Footer';
import Legend from './components/Legend';
import AccessBanner from './components/AccessBanner';
import LayerA from './components/layers/LayerA';
import LayerB from './components/layers/LayerB';
import LayerC from './components/layers/LayerC';
import ConnectorAB from './components/layers/ConnectorAB';
import ConnectorBC from './components/layers/ConnectorBC';

export default function App() {
  return (
    <I18nProvider>
      <Header />
      <div className="ecosystem">
        <LayerA />
        <ConnectorAB />
        <LayerB />
        <ConnectorBC />
        <AccessBanner />
        <LayerC />
        <Legend />
      </div>
      <Footer />
    </I18nProvider>
  );
}
